module.exports = __webpack_public_path__ + "static/media/steak.74119496.jpg";